import { createContext, useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { workItemPatchTitle } from '../lib/clusterMeta.js';
import { lessonReviewPath } from '../lib/workItems.js';
import type { WorkItemSummary } from '../types/workflow.js';

export const QueueItemsContext = createContext<readonly WorkItemSummary[]>([]);

export function NewLessonQuestionLink({ item }: { item: WorkItemSummary }) {
  const items = useContext(QueueItemsContext);
  const [searchParams] = useSearchParams();
  const id = item.intendedParent?.newLessonWorkItemId;
  if (!id) return null;
  const lesson = items.find((candidate) => candidate.workItemId === id && candidate.courseKey === item.courseKey);
  const title = lesson ? workItemPatchTitle(lesson) : null;
  const context = new URLSearchParams(searchParams);
  context.set('courseKey', item.courseKey);
  return <Link className="text-blue-700 underline" to={lessonReviewPath(id, context)} onClick={(event) => event.stopPropagation()}>
    Question for the new lesson{title ? `: ${title}` : ''}
  </Link>;
}
